import React, { useEffect, useState } from "react";
import api from "../utils/api";
import {
  FaWhatsapp,
  FaFacebook,
  FaEnvelope,
} from "react-icons/fa";

export default function ContactOwner() {
  const [contactInfo, setContactInfo] = useState(null);
  const [loading, setLoading] = useState(true);

  // ✅ تحميل بيانات التواصل من السيرفر
  useEffect(() => {
    const fetchContactInfo = async () => {
      try {
        const res = await api.get("/settings/contact-info");
        setContactInfo(res.data);
      } catch (err) {
        console.error("❌ فشل تحميل بيانات التواصل", err);
      } finally {
        setLoading(false);
      }
    };
    fetchContactInfo();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-900 text-yellow-400 text-2xl">
        ⏳ جاري تحميل بيانات التواصل...
      </div>
    );
  }

  if (!contactInfo || (!contactInfo.whatsapp && !contactInfo.facebook && !contactInfo.email)) {
    return (
      <div className="min-h-screen flex flex-col justify-center items-center bg-gray-900 text-center text-gray-300">
        <h1 className="text-4xl font-bold text-yellow-400 mb-6">تواصل مع صاحب النظام</h1>
        <p className="text-lg">📭 لا توجد بيانات تواصل متاحة حاليًا.</p>
        <p className="text-sm text-gray-400 mt-2">سيتم إضافتها قريبًا من قِبل الأدمن.</p>
      </div>
    );
  }

  // 🔗 تجهيز اللينكات
  const contacts = [
    contactInfo.whatsapp && {
      name: "واتساب",
      url: `https://wa.me/${contactInfo.whatsapp}`,
      icon: (
        <FaWhatsapp
          className="text-green-400 group-hover:text-white transition"
          size={60}
        />
      ),
      bg: "bg-gradient-to-br from-green-500 to-green-700",
    },
    contactInfo.facebook && {
      name: "فيسبوك",
      url: contactInfo.facebook,
      icon: (
        <FaFacebook
          className="text-blue-500 group-hover:text-white transition"
          size={60}
        />
      ),
      bg: "bg-gradient-to-br from-blue-600 to-blue-800",
    },
    contactInfo.email && {
      name: "بريد إلكتروني",
      url: `mailto:${contactInfo.email}`,
      icon: (
        <FaEnvelope
          className="text-yellow-400 group-hover:text-white transition"
          size={60}
        />
      ),
      bg: "bg-gradient-to-br from-yellow-400 to-yellow-600",
    },
  ].filter(Boolean); // ✅ إزالة الفارغين

  return (
    <div className="min-h-screen flex flex-col justify-center items-center bg-gradient-to-br from-gray-900 to-gray-800 p-6">
      <h1 className="text-4xl font-bold text-yellow-400 mb-10 text-center">
        تواصل مع صاحب النظام
      </h1>

      <div className="grid gap-8 w-full max-w-4xl grid-cols-1 sm:grid-cols-2 md:grid-cols-3">
        {contacts.map((c, idx) => (
          <a
            key={idx}
            href={c.url}
            target="_blank"
            rel="noopener noreferrer"
            className={`group rounded-2xl shadow-lg p-6 flex flex-col justify-center items-center text-center transform transition hover:scale-105 hover:shadow-2xl ${c.bg}`}
          >
            {c.icon}
            <h2 className="text-2xl mt-4 font-semibold text-white">{c.name}</h2>
          </a>
        ))}
      </div>
    </div>
  );
}
